import { WrenchOutlineIcon } from './WrenchOutlineIcon';

/**
 * author: Google
 * id 040BA3F6-86B3-4597-9EBE-C6D6A916091D
 * name wrench-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wrench-outline.svg
 * tags
 * - Hardware / Tools 
 */
export const BuildOutlineIcon = WrenchOutlineIcon;
export default BuildOutlineIcon